module.exports = __webpack_public_path__ + "static/media/SYS.91a0ca28.svg";